import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FiTruck, 
  FiTag, 
  FiImage, 
  FiSearch, 
  FiZap, 
  FiDownload, 
  FiUsers,
  FiGrid
} from 'react-icons/fi';
import styles from './Sidebar.module.css';

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: FiGrid, path: '/dashboard', active: true },
  { id: 'suppliers', label: 'Gestion des fournisseurs', icon: FiTruck, disabled: true },
  { id: 'categories', label: 'Gestion des catégories', icon: FiTag, disabled: true },
  { id: 'images', label: 'Gestion des images', icon: FiImage, disabled: true },
  { id: 'search-internal', label: 'Recherche interne', icon: FiSearch, disabled: true },
  { id: 'search-ai', label: 'Recherche externe IA', icon: FiZap, disabled: true },
  { id: 'download', label: 'Téléchargement et export', icon: FiDownload, disabled: true },
  { id: 'users', label: 'Gestion des utilisateurs', icon: FiUsers, path: '/users', disabled: false },
];

function Sidebar() {
  const navigate = useNavigate();

  const handleMenuClick = (item) => {
    if (!item.disabled && item.path) {
      navigate(item.path);
    }
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.logo}>
        <img 
          src="/logo.jpg" 
          alt="Xanlite" 
          className={styles.logoImage}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <h2 style={{ display: 'none' }}>Xanlite</h2>
      </div>
      
      <nav className={styles.menu}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.id}
              className={`${styles.menuItem} ${item.active ? styles.active : ''} ${item.disabled ? styles.disabled : ''}`}
              onClick={() => handleMenuClick(item)}
            >
              <Icon className={styles.menuIcon} />
              <span className={styles.menuLabel}>{item.label}</span>
            </div>
          );
        })}
      </nav>
    </div>
  );
}

export default Sidebar;
